import React from "react";
import { Grid, Typography, Button } from "@material-ui/core";
import { AccountCircle } from "@material-ui/icons";
import { useHistory } from "react-router";
import { AppRouteURI } from "router/RoleBasedAccess";
import useStyles from "components/Home/Styles";
import asu_logo from "../../assets/asu_logo.png";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";
import { useSelector } from "react-redux";
import AboutSection from "./AboutSection";

const HeroContainer = () => {
  const classes = useStyles();
  const history = useHistory();
  const { isMobile } = useGetViewPortDimensions();
  const { loggedIn } = useSelector((state) => state.auth);

  return (
    <Grid
      container
      item
      className={
        isMobile
          ? classes.landingPageContainerResponsive
          : classes.landingPageContainer
      }
      style={
        isMobile
          ? {
              backgroundSize: `cover`,
              backgroundPosition: 'center top',
            }
          : {}
      }
    >
      <Grid item xs={12}>
        <Grid container className={classes.signInComponent}>
          <Grid item>
            {!loggedIn && (
              <Button
                className={classes.signInButton}
                onClick={() => history.push(AppRouteURI.LOGIN)}
              >
                <Grid container className={classes.signInBox}>
                  <Grid item className={classes.accountIcon}>
                    <AccountCircle fontSize="large" />
                  </Grid>
                  <Grid item>
                    <Typography
                      component="div"
                      variant="body2"
                      className={classes.signInText}
                    >
                      Sign in
                    </Typography>
                  </Grid>
                </Grid>
              </Button>
            )}
          </Grid>
          <Grid item>
            <img
              src={asu_logo}
              className={classes.applogo}
              alt="asu"
              width="auto"
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} className={classes.landingPageHero}>
        <Typography
          component="div"
          variant="h1"
          className={classes.landingPageTitle}
        >
          AZ CuRVE
        </Typography>
        <Typography
          component="div"
          variant="body2"
          className={classes.landingPageDescription}
          style={{ fontSize: "20px" }}
        >
          The Arizona Colorado River Visualization Enterprise (CuRVE) is an
          interactive, visualization-based tool that enables stakeholders to
          explore datasets and analyses regarding the impacts of Colorado River
          shortage in Arizona.
        </Typography>
        <Button
          variant="contained"
          className={classes.exploreButton}
          onClick={() => history.push(AppRouteURI.SCENARIO)}
          // TODO: public view routing
          // onClick={() => {
          //   if (loggedIn) {
          //     history.push(AppRouteURI.SCENARIO);
          //   } else {
          //     history.push(AppRouteURI.PUBLIC + AppRouteURI.PUBLIC_MAP_VIZ);
          //   }
          // }}
        >
          EXPLORE
        </Button>
      </Grid>
      <Grid item xs={12} className={classes.landingPageGradient}>
        {/* {!isMobile ? <AboutSection/> : null} */}
        <AboutSection />
      </Grid>
    </Grid>
  );
};

export default HeroContainer;
